import { UsuarioVinculo } from '../../modules/types/UsuarioVinculo';
import { UsuarioVinculoDto } from '../../modules/types/UsuarioVinculoDto';
import { Interface } from '../../modules/types/interface';
import httpClient from '../httpClient';

const API_URL = '/api/usuario-vinculos';

export async function createUsuarioVinculo(data: UsuarioVinculoDto) {
  try {
    const response = await httpClient.post(API_URL, data);
    return response.data;
  } catch (error) {
    console.error('Erro ao criar vínculo de usuário:', error);
    throw new Error('Erro ao criar vínculo de usuário: ' + error);
  }
}

export async function getAllUsuarioVinculos(): Promise<UsuarioVinculo[]> {
  try {
    const response = await httpClient.get(API_URL);
    if (response.data && Array.isArray(response.data.registros)) {
      return response.data.registros;
    }
    return [];
  } catch (error) {
    console.error('Erro ao obter lista de vínculos:', error);
    throw new Error('Erro ao obter lista de vínculos: ' + error);
  }
}
export async function getUsuarioVinculosByUsuarioId(
  userId: number,
): Promise<UsuarioVinculo[]> {
  try {
    const response = await httpClient.get(`${API_URL}/user/${userId}`);

    if (response.data && Array.isArray(response.data.registros)) {
      return response.data.registros;
    }
    return [];
  } catch (error) {
    console.error('Erro ao obter lista de vínculos:', error);
    throw new Error('Erro ao obter lista de vínculos: ' + error);
  }
}
export async function getUsuarioVinculoById(id: number) {
  try {
    const response = await httpClient.get(`${API_URL}/${id}`);
    return response.data;
  } catch (error) {
    console.error(`Erro ao obter vínculo com ID ${id}:`, error);
    throw new Error(`Erro ao obter vínculo com ID ${id}: ` + error);
  }
}

export async function updateUsuarioVinculo(
  id: number,
  data: Partial<UsuarioVinculoDto>,
) {
  try {
    const response = await httpClient.patch(`${API_URL}/${id}`, data);
    return response.data;
  } catch (error) {
    console.error(`Erro ao atualizar vínculo com ID ${id}:`, error);
    throw new Error(`Erro ao atualizar vínculo com ID ${id}: ` + error);
  }
}

export async function deleteUsuarioVinculo(id: number) {
  try {
    const response = await httpClient.delete(`${API_URL}/${id}`);
    return response.data;
  } catch (error) {
    console.error(`Erro ao deletar vínculo com ID ${id}:`, error);
    throw new Error(`Erro ao deletar vínculo com ID ${id}: ` + error);
  }
}

export async function getInterfaces(type: string): Promise<Interface> {
  try {
    const response = await httpClient.get(`${API_URL}/interfaces/${type}`);
    return response.data;
  } catch (error) {
    console.error(`Erro ao obter vínculo com ID ${type}:`, error);
    throw new Error(`Erro ao obter vínculo com ID ${type}: ` + error);
  }
}

export async function checkPendingRequest() {
  try {
    const response = await httpClient.get(`${API_URL}/verificar-pendencia`);
    return response.data;
  } catch (error) {
    console.error('Erro ao verificar pendência:', error);
    throw new Error('Erro ao verificar pendência: ' + error);
  }
}

export async function validarUsuarioVinculo(data: {
  cpf: string;
  senha: string;
}) {
  try {
    const response = await httpClient.post(
      '/api/auth/validar-usuario-vinculo',
      data,
    );
    return response.data;
  } catch (error) {
    console.error('Erro ao validar usuário:', error);
    throw error;
  }
}
